// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class AutoLoginResource extends Resource {
    login(data: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            'auth/auto-login/',
            'POST',
            data,
        ).then((response) => response.data);
    }
}
